module.exports = __webpack_public_path__ + "img/placeholder_video.2b086026.svg";